import React from 'react';
import { PrimaryLink } from '../../../types';
import { NavItemText } from '../../styles';
import { NavLink } from './styles';

export type NavLinkMenuProps = {
  navItem: PrimaryLink;
};

const NavLinkMenu: React.FC<NavLinkMenuProps> = ({ navItem }) => (
  <NavLink
    key={navItem.name}
    href={navItem.url}
    onClick={navItem.onClick}
    aria-label={navItem.screenReaderText}>
    <NavItemText>{navItem.name}</NavItemText>
  </NavLink>
);

export default NavLinkMenu;
